import { plainToInstance } from 'class-transformer';
import { TestDto } from '@/src/models/TestDto';
import request from '@/src/apis/axios';
import { ListResponse } from '@/src/types/common';

const URL = {
  getTestDataList: '/notice',
};

export const getTestDataList = async () => {
  const { data } = await request<ListResponse<TestDto>>({
    method: 'get',
    url: URL.getTestDataList,
  });

  return plainToInstance(TestDto, data.rows);
};

export const getTestDataById = async (id: number) => {
  const { data } = await request<ListResponse<TestDto>>({
    method: 'get',
    url: `${URL.getTestDataList}/${id}`,
  });

  return plainToInstance(TestDto, data.rows);
};

export const getTestDataByPage = async (page: number, pageSize: number) => {
  const { data } = await request<ListResponse<TestDto>>({
    method: 'get',
    url: `${URL.getTestDataList}/infinite`,
    queryParams: {
      page,
      pageSize,
    },
  });

  return plainToInstance(TestDto, data.rows);
};
